import { formatDate } from '@/common/utils/formatters'
import { CompanyData } from '@/features/companies/types/companies.type'
import ModalUpdateClientSince from './ModalUpdateClientSince'
import Skeleton from '@/common/components/Skeleton'

export default function CompanyDatesInfo({company, companyIsPending}: {company?: CompanyData, companyIsPending: boolean}) {
  return (
    <div className="flex items-center gap-2 w-full">
      <div className="w-full bg-white-200 rounded-lg p-4 space-y-1">
        <p className="text-[11px] leading-3">Data de inclusão no sistema</p>
        <p className="text-xs">
          {companyIsPending ? <Skeleton className='w-[65px]' /> : company?.created_at && formatDate(new Date(company?.created_at))}
        </p>
      </div>
      <div className="w-full bg-white-200 rounded-lg p-4 space-y-1">
        <p className="text-[11px] leading-3">Membro Tcard desde</p>
        <div className="flex gap-2 items-center">
          <p className="text-xs">
            {companyIsPending ? <Skeleton className='w-[65px]' /> : company?.client_since ? formatDate(new Date(company?.client_since)) : '--'}
          </p>
          <ModalUpdateClientSince clientSince={company?.client_since} disabled={companyIsPending} />
        </div>
      </div>
    </div>
  )
}
